<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="withdrawalsList"
        :search="search"
        class="elevation-1 pb-3"
        :loading="loading"
        :loading-text="$t('loadingData')"
        :no-data-text="$t('noDataText')"
        :no-results-text="$t('noResultsText')"
        :items-per-page="100"
        hide-default-footer
      >
        <template v-slot:top>
          <div class="row no-gutters d-flex align-center pa-4">
            <div
              v-if="totalWithdrawals"
              class="d-flex align-center"
            >
              <v-icon left>mdi-cash-fast</v-icon>
              <span>{{ totalWithdrawals }}</span>

              <span class="ml-2">
                {{ $tc("withdrawalsPlurals", totalWithdrawals) }}
              </span>

              <v-progress-circular
                v-if="fetchingWithdrawals"
                indeterminate
                :size="20"
                color="primary"
                class="ml-2"
              ></v-progress-circular>
            </div>
            <v-spacer />
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </div>
        </template>

        <template v-slot:[`item.player_id`]="{ item }">
          <v-btn @click="$copy(item.player_id)" x-small>
            {{ item.player_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.player_phone`]="{ item }">
          {{ item.player_phone || "-" }}
        </template>

        <template v-slot:[`item.player_email`]="{ item }">
          {{ item.player_email || "-" }}
        </template>

        <template v-slot:[`item.withdraw_id`]="{ item }">
          <v-btn @click="$copy(item.withdraw_id)" x-small>
            {{ item.withdraw_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.player_register`]="{ item }">
          {{ $handleDate(item.player_register).date }}
        </template>

        <template v-slot:[`item.withdraw_value_requested`]="{ item }">
          <span class="orange--text">{{ item.withdraw_value_requested }}</span>
        </template>

        <template v-slot:[`item.withdraw_value_consolidated`]="{ item }">
          <span class="red--text">{{ item.withdraw_value_consolidated }}</span>
        </template>

        <template v-slot:[`item.withdraw_final_date`]="{ item }">
          {{ $handleDate(item.withdraw_final_date).date }}
        </template>

        <template v-slot:[`item.withdraw_status`]="{ item }">
          <v-chip
            small
            :class="handleStatusUI(item.withdraw_status)"
          >
            {{ item.withdraw_status }}
          </v-chip>
        </template>

        <template v-slot:[`item.affiliate_id`]="{ item }">
          <div v-if="item.affiliate_id == null">
            -
          </div>
          <v-btn v-else @click="$copy(item.affiliate_id)" x-small>
            {{ item.affiliate_id }}
          </v-btn>
        </template>
  
        <template v-slot:[`item.affiliate_name`]="{ item }">
          {{ item.affiliate_name || "-" }}
        </template>
  
        <template v-slot:[`item.local_id`]="{ item }">
          <div v-if="item.local_id == null">
            -
          </div>
          <v-btn v-else @click="$copy(item.local_id)" x-small>
            {{ item.local_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.local_name`]="{ item }">
          {{ item.local_name || "-" }}
        </template>
      </v-data-table>
      <v-pagination
        v-if="pageCount > 0 && (withdrawalsList && withdrawalsList.length > 0)"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        class="pb-3"
      ></v-pagination>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "relatorio-apostas",
  data: (vm) => ({
    loading: false,
    fetchingWithdrawals: false,
    page: 1,
    pageCount: 0,
    timeoutId: 0,
    latestRangeDate: {},
    cachedPage: {},
    search: "",
    totalWithdrawals: 0,
    headers: [
      { text: vm.$t("withdrawalID"), value: "withdraw_id", align: "no-wrap" },
      { text: vm.$t("playerId"), value: "player_id", align: "no-wrap" },
      { text: vm.$t("name"), value: "player_name", align: "no-wrap" },
      { text: "DDD", value: "player_ddd", align: "no-wrap" },
      { text: vm.$t("phone"), value: "player_phone", align: "no-wrap" },
      { text: "Email", value: "player_email", align: "no-wrap" },
      { text: "CPF", value: "player_document", align: "no-wrap" },
      { text: vm.$t("registrationDate"), value: "player_register", align: "no-wrap" },
      { text: vm.$t("entryId"), value: "withdraw_entrie", align: "no-wrap" },
      { text: vm.$t("withdrawalRequisted"), value: "withdraw_value_requested", align: "no-wrap" },
      { text: vm.$t("consolidatedValue"), value: "withdraw_value_consolidated", align: "no-wrap" },
      { text: vm.$t("finishedIn"), value: "withdraw_final_date", align: "no-wrap" },
      { text: vm.$t("provider"), value: "withdraw_provider", align: "no-wrap" },
      { text: "Status", value: "withdraw_status", align: "no-wrap" },
      { text: vm.$t("affiliateId"), value: "affiliate_id", align: "no-wrap" },
      { text: vm.$t("affiliateName"), value: "affiliate_name", align: "no-wrap" },
      { text: vm.$t("localManagerId"), value: "local_id", align: "no-wrap" },
      { text: vm.$t("localManagerName"), value: "local_name", align: "no-wrap" },
    ],
    withdrawalsList: [],
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    rangeDateHasChanged() {
      if (!this.latestRangeDate.data_inicio) return false;
      return this.latestRangeDate.data_inicio != this.rangeDate.data_inicio ||
        this.latestRangeDate.data_final != this.rangeDate.data_final
    }
  },

  mounted() {
    this.debouncedFetchTotalwithdrawalsByRange();
  },

  watch: {
    rangeDate() {
      this.debouncedFetchTotalwithdrawalsByRange();
    },
    saveFilters(bool) {
      bool && this.fetchWithdrawalsReport();
    },
    page() {
      this.fetchWithdrawalsReport(true);
    },
    totalWithdrawals(withdrawal) {
      if (withdrawal == 0) {
        this.withdrawalsList = [];
      }
    }
  },

  methods: {
    debouncedFetchTotalwithdrawalsByRange() {
      clearTimeout(this.timeoutId);
      const currentTimeout = setTimeout(()=> {this.fetchTotalWithdrawalsByRange()}, 500);
      this.timeoutId = currentTimeout;
    },

    async fetchTotalWithdrawalsByRange() {
      this.fetchingWithdrawals = true;
      const body = {
        ...this.rangeDate,
      }
      await this.$axios
        .post(`${this.$prefix()}/players/countTotalwithdrawalsByRange`, this.$formdata(body))
        .then((response) => {
          this.totalWithdrawals = Number(response.data.dados.qty_withdrawals);
          this.pageCount = Math.ceil(this.totalWithdrawals / 100);
          this.fetchingWithdrawals = false;
        }).catch(() => this.fetchingWithdrawals = false);
    },
    async fetchWithdrawalsReport(isChangingPage) {
      if (isChangingPage) {
        this.$store.commit("setGroupExport", "");
      }
      const body = {
        ...this.rangeDate,
        export: this.exportDoc,
      }

      if (this.exportDoc && !isChangingPage) {
        await this.$request.exportDoc(
          `${this.$prefix()}/players/withdrawalsReport`,
          body,
          this.exportDoc,
          this.rangeDate
        );
        return
      }

      body.page_number = this.page - 1;
      this.loading = true;
      this.withdrawalsList = []
      
      if (this.cachedPage[this.page] && !this.rangeDateHasChanged) {
        this.withdrawalsList = this.cachedPage[this.page]
        this.loading = false;
        this.$store.commit("setFeedbackProgress", false);
        this.$store.commit("setSave", false);
        this.$store.commit("DisabledSave", false);
        return
      }

      await this.$request
        .post(`${this.$prefix()}/players/withdrawalsReport`, body)
        .then((resp) => {
          this.withdrawalsList = resp.dados;
          this.cachedPage[this.page] = this.withdrawalsList;
          this.loading = false;
          this.latestRangeDate = {...this.rangeDate}
        })
        .catch(() => this.loading = false);
    },

    handleStatusUI(status) {
      if (status == this.$t("withdrawalStatus.requested")) return "orange";
      if (status == this.$t("withdrawalStatus.authorized")) return "green";
      if (status == this.$t("withdrawalStatus.consolidated")) return "red";
      if (status == this.$t("withdrawalStatus.cancelled")) return "purple";
    }
  }
}
</script>